import React from 'react'
import ContactInfo from './ContactInfo'
import Education from './Education'
import ServiceLine from './ServiceLine'
import { OnboardingProvider, OnboardingContext } from './../../contexts/OnboardingContext'
import OnboardingLayout from './../../_global/OnboardingLayout'
import WorkExperience from './WorkExperience'
import WorkPreferences from './WorkPreferences'
import Pitch from './Pitch'
import ProfileReview from './ProfileReview'
import ErrorBoundary from './../../_global/ErrorBoundary'

const renderComponent = (step) => {
  switch (step) {
    case 0:
      return <ContactInfo />
    case 1:
      return <ServiceLine />
    case 2:
      return <Education />
    case 3:
      return <WorkExperience />
    case 4:
      return <Education /> // TODO - removed accomplishments, moved certain parts to Education
    case 5:
      return <WorkPreferences />
    case 6:
      return <Pitch />
    case 7:
      return <ProfileReview />
    default:
      return <ContactInfo />
  }
}

const Onboarding = () => {
  return (
    <OnboardingProvider>
      <OnboardingContext.Consumer>
        {({ step }) => {
          return (
            <OnboardingLayout>
              <ErrorBoundary>{renderComponent(step)}</ErrorBoundary>
            </OnboardingLayout>
          )
        }}
      </OnboardingContext.Consumer>
    </OnboardingProvider>
  )
}

export default Onboarding
